import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../features/user";
import { showErrorDialog } from "../../features/errorDialog";
import axios from "axios";
import { API_OK, API_URL, API_EXCEPTION, DEFAULT_ERROR_TEXT } from '../../Constants';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {handleApiErrorMessage} from "../../Helper"
import { logout } from "../../features/user";
import { useSearchParams } from "react-router-dom";
import cookie from "js-cookie";


export function LoginByToken() {
    const [loginSuccessful, setLoginSuccessful] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    
    useEffect(() => {
        let tokenParam = searchParams.get("token");
        let continueRoute = searchParams.get("continue");
        if(tokenParam !== null && (typeof tokenParam !== "undefined")){
            let  headers = {
                token: tokenParam
            }

            let errorMessage = t(DEFAULT_ERROR_TEXT);

            axios.get(API_URL + '/getStat', {headers})
            .then(
                ({ data }) => {
                if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK) ){
                    localStorage.setItem('show_red_inactive_lines', data.showRedInactiveLines);
                    localStorage.setItem('allow_unblock_line_from_invalid_imei', data.allowUnblockLineFromInvalidImei);
                    localStorage.setItem('portal_access', JSON.stringify(data.portalAccess || {}));
                    localStorage.setItem('community_type', data.community_type || 'REGULAR');
                    localStorage.setItem('block_list_policy', JSON.stringify(data.blockListPolicy || {}));
                    dispatch(login({token : tokenParam, community_name: data.name, smsWatchSystemAllow: data.smsWatchSystemAllow}));
                    // guard: webConfig may be missing — don't let it block navigation (the tab title is also set per-reseller in App.js)
                    if(data.webConfig && data.webConfig.title){
                        document.title = data.webConfig.title;
                    }
                    setLoginSuccessful(true);
                    if(continueRoute !== null && (typeof continueRoute !== "undefined")){
                        navigate("/"+continueRoute);
                    }else{
                        navigate("/dashboard");
                    }
                }else{
                    if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
                    errorMessage = data["message"];
                    }
                    handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, null, navigate);
                }
                }).catch((error) => {
                handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, null, navigate);
            });
        }
      }, []);

    return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={[
                    {
                      mt: 2
                  }
                ]}
            >
                <div>{(loginSuccessful ? "Login Successful" : "Login Required")}</div>
            </Box>
    );
}